

import apiWorker from '../apiWorker'

const forms = {
    findByIdentifier    : (id) => apiWorker('get',  `/v1/flow_assignments/${id}`),
    update              : (id, data) => apiWorker('patch',  `/v1/flow_assignments/${id}`, data),
}

export default forms;